var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHashVideo = function SvgHashVideo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.393 1.003a1 1 0 0 1 .888 1.1l-.257 2.406h1.824a1 1 0 0 1 0 2h-2.037l-.07.658H8.729l.07-.658H5.368l-.349 3.267H6v2H4.805l-.249 2.328a1 1 0 0 1-1.989-.212l.226-2.115H1a1 1 0 1 1 0-2h2.007l.348-3.268H1.642a1 1 0 0 1 0-2h1.927l.28-2.618a1 1 0 0 1 1.988.212L5.58 4.51h3.433l.28-2.618a1 1 0 0 1 1.1-.888",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17191C",
    d: "M7.829 9.105A.83.83 0 0 0 7 9.934v2.762c0 .457.371.829.829.829h3.038a.83.83 0 0 0 .829-.83V9.935a.83.83 0 0 0-.829-.83zM13.18 9.74l-.932.746v1.657l.933.746c.18.145.448.016.448-.215V9.956a.276.276 0 0 0-.448-.216"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHashVideo);
export { ForwardRef as Icon };
export default "img/element-icons/roomlist/hash-video.0d44220.svg";